<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Riwayat Transaksi Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-tabs class="tabs-vo no-slider" v-if="serialTypeList.length > 0">
							<template v-for="serial in serialTypeList">
								<v-tab
									:key="serial.serial_type_id"
									class="rounded-xl"
									:disabled="tab_disabled"
									v-if="serial.serial_type_master_name !== 'repeatorder'"
									@click="changeTabSerial(serial.serial_type_id)">
									Serial {{ serial.serial_type_label }}
								</v-tab>
							</template>
						</v-tabs>
						<v-progress-circular
							indeterminate
							color="primary"
							v-else>
						</v-progress-circular>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<template v-if="serialType.length > 0">
					<SerialList ref="serialList" :serial_id="serial_id"></SerialList>
				</template>
			</v-scroll-x-transition>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SerialList from './SerialList';

export default {
	components: {
		SerialList
	},
	data() {
		return {
			tab_disabled: false,
			serial_id: '',
			serialTypeList: []
		}
	},
	computed: {
		...mapState('serial', ['serialType']),
	},
	methods: {
		...mapActions('serial', ['getSerialType']),

		getData() {
			this.getSerialType().then(() => {
				let serials = []
				this.serialType.map(serial => {
					if (serial.serial_type_label == 'Ceria') serials[0] = serial
					else if (serial.serial_type_label == 'Ekonomis') serials[1] = serial
					else if (serial.serial_type_label == 'Premium') serials[2] = serial
					else if (serial.serial_type_label == 'Supreme') serials[3] = serial
					else if (serial.serial_type_label == 'Free') serials[4] = serial
				})

				// serials[2].serial_type_label = 'Premium'
				this.serialTypeList = serials

				this.serial_id = this.serialTypeList[0].serial_type_id
				setTimeout(() => {
					this.$refs.serialList.getData()
				}, 100)
			})
		},
		changeTabSerial(id) {
			this.serial_id = id
			this.tab_disabled = true
			setTimeout(() => {
				this.$refs.serialList.getData()
			}, 100)
			setTimeout(() => {
				this.tab_disabled = false
			}, 500)
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Riwayat Transaksi Serial`)
		this.getData()
	},
};
</script>